/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-lonely-if */
import React, { useMemo, useState, useContext } from 'react';
import { globalContext } from 'contexts/globalContext';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import OrangeButton from 'components/Common/OrangeButton';
import ActionButton from 'components/Common/ActionButton';
// import LightBlueButton from 'components/Common/LightBlueButton';
import FeedbackIcon from '@material-ui/icons/Feedback';
import ClickableDiv from 'components/Common/ClickableDiv';
import API from 'api';
import Ad, { Statuses } from 'models/business/Ad';
import Dialog from 'components/Common/Dialog';
import pause from 'assets/pause.png';
import classNames from 'classnames';
import BudgetDisplay from '../BudgetDisplay';
import DateModal from './DateModal';
import Styles from './index.module.css';

function GreenButton({
  children,
  onClick,
  disabled,
}) {
  return (
    <button
      type="button"
      className={Styles.greenButton}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

GreenButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

GreenButton.defaultProps = {
  onClick: () => {},
  disabled: false,
  children: null,
};

const StatusMessages = {
  [Statuses.Incomplete]: '待完成所有設定後，請按下發送上稿需求，設定廣告開始投放日期',
  [Statuses.Online]: '您的廣告正在進行中，請至【我的成效】查看廣告數據',
  [Statuses.Pending]: '您的廣告正在處理中，將在您設定的開始日期上線',
  [Statuses.Stopped]: '您的廣告目前暫停中，若想重啟廣告，請按下左下方恢復廣告',
};

const Modals = {
  Settings: 'incomplete',
  Budget: 'budget',
  Date: 'date',
  Stop: 'stop',
};

function AdDetails({
  ad,
  onChangeAd,
  amounts,
  // updateMaterialOnClick,
  // sendMaterialOnClick,
}) {
  const history = useHistory();
  const [visibleModal, setVisibleModal] = useState();
  const { state } = useContext(globalContext);
  const handleChangeDayBudget = (budget) => {
    const newAd = new Ad(ad);
    newAd.updateBudget(budget);
    newAd.status = Statuses.Incomplete;
    newAd.startDate = newAd.earliestStartingDateForBudgetChange;
    onChangeAd(newAd);
  };

  const handleStopAd = () => {
    const newAd = new Ad(ad);
    newAd.status = Statuses.Stopped;
    onChangeAd(newAd);
    setVisibleModal();
  };

  const handleSubmitAd = async () => {
    const newAd = ad.clone();
    const result = await API.ad.getAdAssets(newAd.id);
    if (!result.error) {
      newAd.injectAssets(result || []);
      onChangeAd(newAd);
    }

    const costSum = JSON.parse(localStorage.getItem('effectCostSum'));
    const amountsNew = JSON.parse(localStorage.getItem('amounts'));

    if (newAd.platform === 'Google') {
      // if (+state.amounts.google < 10000) {
      if (Math.round(+amountsNew.google - +costSum.google) < 10000) {
        setVisibleModal(Modals.Budget);
      } else if (!newAd.fullyValid) {
        setVisibleModal(Modals.Settings);
      } else {
        setVisibleModal(Modals.Date);
      }
    } else {
      // if (+state.amounts.facebook < 10000) {
      if (Math.round(+amountsNew.facebook - +costSum.facebook) < 10000) {
        setVisibleModal(Modals.Budget);
      } else if (!newAd.fullyValid) {
        setVisibleModal(Modals.Settings);
      } else {
        setVisibleModal(Modals.Date);
      }
    }
  };

  const handleCompleteAd = async (finishedAd) => {
    const newAd = finishedAd.clone();
    newAd.status = Statuses.Pending;
    onChangeAd(newAd);
    setVisibleModal();
  };

  const materialSettingOnClick = () => {
    if (ad.isGoogle) history.push('/GoogleResourceSetting', { ad });
    else if (ad.isFacebook)history.push('/FbResourceSetting', { ad });
  };

  const buttonRender = useMemo(() => {
    let message = '更新上稿需求';
    let backgroundColor = '#7c98cc';
    if (ad.status === Statuses.Incomplete) {
      message = '發送上稿需求';
      backgroundColor = '#0CB381';
    } else if (ad.status === Statuses.Stopped) {
      message = '恢復廣告';
    }

    return (
      <ActionButton
        style={{
          color: '#FFFFFF',
          backgroundColor,
          height: 36,
          width: '100%',
          fontSize: 15,
        }}
        onClick={handleSubmitAd}
      >
        {message}
      </ActionButton>
    );
  }, [ad, handleSubmitAd]);

  return (
    <div className={Styles.container}>
      <div className={Styles.row}>
        <div className={Styles.infoBlock}>
          <BudgetDisplay ad={ad} onChangeDayBudget={handleChangeDayBudget} />
        </div>
        <div className={Styles.messageBlock}>
          <div style={{ paddingRight: '5px' }}>
            <FeedbackIcon style={{ fontSize: '35px' }} />
          </div>
          <div>
            <div className={Styles.titleText}>
              {StatusMessages[ad.status] || ''}
            </div>
          </div>
        </div>
        <div className={Styles.infoBlock} />
      </div>
      <div className={classNames(Styles.row, Styles.row_columned)}>
        <div className={Styles.infoBlock} style={{ visibility: [Statuses.Incomplete, Statuses.Stopped].includes(ad.status) ? 'hidden' : 'visible' }}>
          <div className={Styles.titleText}>
            開始日
          </div>
          <div className={Styles.numberText}>
            {ad.startDate.toLocaleDateString()}
          </div>
        </div>
        <div className={Styles.buttonBlock}>
          <OrangeButton onClick={materialSettingOnClick}>素材設定</OrangeButton>
        </div>
        <div className={Styles.buttonBlock}>
          {buttonRender}
        </div>
        <div
          className={Styles.infoBlock}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
          }}
        >
          {[Statuses.Online, Statuses.Pending].includes(ad.status) && (
            <ClickableDiv
              onClick={() => setVisibleModal(Modals.Stop)}
              className={Styles.stoppingText}
            >
              <img src={pause} alt="Pause icon" style={{ width: '36px', height: '36px' }} />
            </ClickableDiv>
          )}
        </div>
      </div>
      {visibleModal === Modals.Settings && (
        <Dialog
          open
          title="設定未完成"
          content={<div>您的廣告仍未完成設定，請在完成設定後，按下發送上稿需求，送出廣告申請</div>}
          onSubmit={() => setVisibleModal()}
          onClose={() => setVisibleModal()}
        />
      )}
      {visibleModal === Modals.Budget && (
        <Dialog
          open
          title="餘額不足"
          content={<div>請先完成儲值，才能發送上稿需求，最低10,000NTD</div>}
          onSubmit={() => setVisibleModal()}
          onClose={() => setVisibleModal()}
        />
      )}
      {visibleModal === Modals.Date && (
        <DateModal
          ad={ad}
          onSubmit={handleCompleteAd}
          onCancel={() => setVisibleModal()}
        />
      )}
      {visibleModal === Modals.Stop && (
        <Dialog
          open
          title="暫停廣告"
          content="若您需要暫停已上線廣告，廣告將需要一個工作天完成調整"
          onSubmit={handleStopAd}
          submitText="停止"
          onClose={() => setVisibleModal()}
          onCancel={() => setVisibleModal()}
          hideCancel={false}
        />
      )}
    </div>
  );
}

AdDetails.propTypes = {
  ad: PropTypes.instanceOf(Ad),
  onChangeAd: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  amounts: PropTypes.object,
  // updateMaterialOnClick: PropTypes.func,
  // sendMaterialOnClick: PropTypes.func,
};

AdDetails.defaultProps = {
  ad: new Ad(),
  onChangeAd: () => {},
  amounts: {},
  // updateMaterialOnClick: () => {},
  // sendMaterialOnClick: () => {},
};

export default AdDetails;
